<template>
    <div>
        <v-client-table v-if="billings" class="dataTables_wrapper" :data="billings" :columns="columns" :options="clientTableOptions">
            <d-col slot="integrations" slot-scope="props" size="small">
                {{ props.row.integrations[0].short_name }}
                <span v-if="props.row.integrations[1]">{{ props.row.integrations[1].short_name }}</span>
            </d-col>
            <d-button-group slot="buttons" slot-scope="props" size="small" class="d-flex justify-content-center">
                <d-button v-if="checkPermission(permissionTypes.billingWrite)" :disabled="checkIfCurrentPlan(props.row.id)" theme="success" :class="{ 'current-btn': checkIfCurrentPlan(props.row.id), active: props.row.id === isActive }" @click="checkPlan(props.row.id)">
                    <span v-if="checkIfCurrentPlan(props.row.id)">Current plan</span>
                    <span v-else>Switch to this plan</span>
                </d-button>
                <d-button v-if="checkIfCurrentPlan(props.row.id) && !checkPermission(permissionTypes.billingWrite)" :disabled="checkIfCurrentPlan(props.row.id)" theme="success" :class="{ 'current-btn': checkIfCurrentPlan(props.row.id), active: props.row.id === isActive }" @click="checkPlan(props.row.id)">
                    <span v-if="">Current plan</span>
                </d-button>
            </d-button-group>
        </v-client-table>
        <d-container class="d-flex justify-content-center" fluid v-else>
            <b-spinner label="Spinning"></b-spinner>
        </d-container>
    </div>
</template>

<script>
import { BillingService } from '@/main';
import notification from '@/mixins/notification';
import permissions from '../../mixins/permissions';

export default {
    mixins: [notification, permissions],

    data() {
        return {
            planCheck: '',
            billings: null,
            showModal: false,

            columns: ['external_name', 'amount_of_transactions', 'domains', 'networks', 'integrations', 'price', 'buttons'],

            clientTableOptions: {
                perPage: 25,
                pagination: { show: false },
                childRowTogglerFirst: false,
                recordsPerPage: [25, 50, 100],
                skin: 'transaction-history table dataTable',
                texts: {
                    limit: 'Show',
                    count: '',
                },
                headings: {
                    external_name: 'Plan',
                    amount_of_transactions: 'Monthly commission',
                    domains: 'Domains',
                    networks: 'Networks',
                    integrations: 'Integrations',
                    price: 'Monthly price',
                    buttons: ' ',
                },
                columnsDisplay: {
                    domains: 'desktop',
                    networks: 'desktop',
                    integrations: 'desktop',
                    price: 'desktop',
                },
            },
        };
    },
    methods: {
        checkIfCurrentPlan(planId) {
            if (! this.userInfo.subscription) {
                return false
            }

            let currentPlanId = parseInt(this.userInfo.subscription.plan.id)
            if (planId === currentPlanId) {
                return true
            } else {
                return false
            }
        },

        async getBilling() {
            this.billings = await BillingService.get()
        },

        async checkPlan(id) {
            try {
                this.planCheck = await BillingService.checkPlan(id)
                this.getPlanApplyings(id)
                this.$store.commit('setPlanId', id)
            } catch(e) {
                if (e.response.status === 400) {
                    this.$swal({
                        title: "Account limit reached! You can't choose this plan.",
                        icon: "error",
                        confirmButtonColor: "#007AFF",
                        confirmButtonText: "Finetune",
                        showCancelButton: true,
                        text: "This plan does not contain all features you have active right now in your Ivanhoe.io account. Click on Finetune to adjust your Ivanhoe.io account."
                    }).then((result) => {
                        if (result.value) {
                            this.$modal.show('finetune')
                        }
                    })
                } else {
                    this.showNotification('error-notification', 'Oops! we have a problem', e.response.data.message)
                }
            }
        },

        async getPlanApplyings(id) {
            try {
                const plans = await BillingService.getPlanApplyings(id)
                this.$store.commit('setPlanApplyingOptions', plans)
            } catch(e) {
                this.showNotification('warn', 'We have a problem', 'Plan not availbe')
                console.log(e)
            }
        },

        show() {
            this.$modal.show('request');
        },
    },

    created() {
        this.getBilling()
    },

    computed: {
        userInfo () {
            return this.$store.getters.userInfo
        },

        isActive () {
            return this.$store.getters.getBillingInfo.planId
        }
    }
};
</script>

<style lang="scss">
    .swal2-container {
        z-index: 1071!important;
    }
</style>
